import React from 'react';
import PropTypes from 'prop-types';
import AutoCompleteFilter from 'components/list/Filters/types/AutoCompleteFilter';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import authHelper from 'helpers/auth';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, isInvalid, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

const CampaignsCreateForm = (props) => {
    const {
        handleSubmit,
        handleSubmitForm,
        invalid,
        pristine,
        submitting,
        translate,
    } = props;

    const isAdmin = authHelper.isAdmin();

    return (
        <FormWrapper>
            <form onSubmit={ handleSubmit(handleSubmitForm) }>
                <Section>
                    { isAdmin &&
                        <Row>
                            <Item>
                                <Field
                                    component={ AutoCompleteFilter }
                                    label='resources.campaigns.fields.accountId'
                                    name='account_id'
                                    optionValue='id'
                                    reference='accounts'
                                    searchBy='name'
                                    searchParams={ {
                                        size: '12',
                                        sort_by: 'name',
                                        sort_direction: 'asc',
                                    } }
                                    source='account_id'
                                />
                            </Item>
                        </Row>
                    }

                    <Row>
                        <Item>
                            <Field
                                component={ RenderTextInputField }
                                fullWidth={ true }
                                label={ translate('resources.campaigns.fields.name') }
                                name='name'
                                validate={ validations.required }
                            />
                        </Item>
                    </Row>
                </Section>

                <Section>
                    <Row>
                        <ButtonWrapper>
                            <SubmitButton
                                disabled={ pristine || submitting || invalid }
                                loading={ submitting }
                            />
                        </ButtonWrapper>
                    </Row>
                </Section>
            </form>
        </FormWrapper>
    );
};

CampaignsCreateForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.user_id) {
                errors.user_id = translate('forms.required');
            }

            if (!values.name) {
                errors.name = translate('forms.required');
            }

            return errors;
        },
    }),
);

export default enhance(CampaignsCreateForm);



// WEBPACK FOOTER //
// ./src/pages/campaigns/create/CampaignsCreateForm.js